import React, { useEffect, useState, useRef } from 'react';
import { motion, useInView, useAnimation } from 'framer-motion';
export function TrustBar() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const [count, setCount] = useState(0);
  const customEase = [0.16, 1, 0.3, 1];
  useEffect(() => {
    if (isInView) {
      let start = 0;
      const end = 360;
      const duration = 2000; // 2 seconds
      const incrementTime = duration / end * 2;
      const timer = setInterval(() => {
        start += 5;
        if (start > end) {
          setCount(end);
          clearInterval(timer);
        } else {
          setCount(start);
        }
      }, incrementTime);
      return () => clearInterval(timer);
    }
  }, [isInView]);
  return <section className="py-16 md:py-24 bg-white border-b border-cream-dark" ref={ref} data-id="element-346">
      <div className="max-w-[90rem] mx-auto px-6 lg:px-12" data-id="element-347">
        <div className="flex flex-col items-center justify-center text-center" data-id="element-348">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 1,
          ease: customEase
        }} className="flex items-baseline gap-4 mb-8" data-id="element-349">
            <span className="font-serif text-6xl md:text-8xl font-light text-copper" data-id="element-350">
              {count}+
            </span>
            <span className="font-sans text-sm md:text-base text-stone uppercase tracking-widest" data-id="element-351">
              training sessions delivered last year
            </span>
          </motion.div>

          <motion.div initial={{
          opacity: 0
        }} animate={isInView ? {
          opacity: 1
        } : {}} transition={{
          duration: 1,
          delay: 0.4,
          ease: customEase
        }} className="flex flex-wrap justify-center items-center gap-x-4 gap-y-2 font-sans text-xs uppercase tracking-[0.15em] text-stone" data-id="element-352">
            <span data-id="element-353">Brisbane · Sydney · Melbourne</span>
            <span className="hidden md:inline text-cream-dark" data-id="element-354">|</span>
            <span data-id="element-355">Beginner-Friendly</span>
            <span className="hidden md:inline text-cream-dark" data-id="element-356">|</span>
            <span data-id="element-357">Private Classes</span>
            <span className="hidden md:inline text-cream-dark" data-id="element-358">|</span>
            <span data-id="element-359">Makeup Services</span>
          </motion.div>
        </div>
      </div>
    </section>;
}